module.exports = __webpack_public_path__ + "static/media/posts-small.c5d1fc7d.svg";